import { useCallback } from "react";

import * as Repository from "@/components/features/hotel-notification-settings/model/repository";

import type * as FormModelType from "../type";

type Props = {
	inputModel: FormModelType.HotelNotificationSettingFormModel["InputModel"];
	onResetViewModel: () => void;
};

export const useUpdateHotelSettings = ({ inputModel, onResetViewModel }: Props) => {
	const { onUpdateHotelNotificationSettings: _onUpdateHotelNotificationSettings } =
		Repository.Mutation.useHotelNotificationSettingsMutation({ onResetViewModel });

	const onUpdateHotelNotificationSettings = useCallback(
		async () => await _onUpdateHotelNotificationSettings(inputModel),
		[inputModel, _onUpdateHotelNotificationSettings],
	);

	return {
		onUpdateHotelNotificationSettings,
	};
};
